export default "__VITE_ASSET__SB0ZFM0F__"